/*import {
    BrowserRouter as Router,
    Link,
    Route
  } from 'react-router-dom'*/
import Cookies from 'js-cookie'

const login = () => {

    // FOR TESTING: https://www.gym-bro-bot.com/.netlify/functions/login_user?refresh_token=
    // If user is logged in, take em straight to the user page 
    // Do this by trying to refresh the token and get the new data
    // If already authenticated 
    /*if (Cookies.get('isAuthenticated')) {
        // Get the refresh token to check that it is valid
        let refresh_token = Cookies.get('refresh_token');
        console.log("Refresh token: " + refresh_token);
        // If not valid, set authenticated var. to false, and it will exit this if statement 
        if (refresh_token === undefined || refresh_token === "undefined" || refresh_token === null || refresh_token === "null") {
            console.log("Failed auto login");
            Cookies.set('isAuthenticated', false);
        }
        // If there is a valid refresh token, redirect to the discordLogin page without having the user to re-login
        else {
            return '/discordLogin';
        }
    }*/

    // If it makes it here, it means that the above failed. The user is not authenticated yet 

    // GET method: get the url for the request in order for the user to login and accept the scopes
    const url = new URL('https://discord.com/api/oauth2/authorize?');
    const params = new URLSearchParams({
                    'response_type': 'code',
                    'client_id': '949731498808979557',
                    'scope': 'guilds identify guilds.members.read',
                    'state': '123',
                    'redirect_uri': 'https://gym-bro-bot.netlify.app/callback'
    });

    const login_url = url + params;
    return login_url;
}

export const MenuItems = [
    {
        title: 'Home',
        url: '/',
        cName: 'nav-links'
    },

    {
        title: 'About',
        url: '/about',
        cName: 'nav-links'
    },

    {
        title: 'Login',
        url: login(),
        cName: 'nav-links'
    }

]